export default "__VITE_ASSET__CwXkfIL$__"